import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

// ================ Reducer ================ //

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  return state;
}

// ================ Action creators ================ //

// ================ Thunks ================ //

export const loadData = () => {
  // Since verify email happens in separate tab, current user's data might be updated
  return fetchCurrentUser();
};
